<header class="header is-flex is-align-items-center" id="header">
  <nav
    aria-label="main navigation"
    class="is-flex is-align-items-center is-justify-content-space-between is-fullwidth"
    role="navigation">
    <div class="navbar-start is-flex is-align-items-center">
      @if (!navMenuOpen) {
      <div class="wrapper-close-x">
        @if (!disableOptions()) {
        <div class="toggle-icon" (click)="onMenuClicked()">
          <span></span>
          <span></span>
          <span></span>
        </div>
        }
        <a routerLink="/">
          <img src="assets/img/Bueno-logo-Blue.png" alt="Logo" class="logo" />
        </a>
      </div>
      }
    </div>
    <div class="is-flex is-align-items-center is-justify-content-space-between">
      @if (disableOptions()) {
      <app-button-primary
        class="bueno-navbar-item-list is-flex is-align-items-center"
        (onClick)="onLogout(); closeAllDropdowns(); $event.stopPropagation()">
        {{'LOGOUT'|translate}}
      </app-button-primary>
      }
      <!-- <a
        class="header-menu-icon chat is-flex is-align-items-center is-justify-content-center"
        (click)="openFeedbackModal()">
        <mat-icon class="header-icon" svgIcon="bueno-chat"></mat-icon>
      </a> -->
      @if (!disableOptions()) {
      <app-subscription-badge class="subscription-badge-slot" [user]="user" />
      @if (isSecondary) {
      <div class="secondary-user-badge">
        <ng-icon name="heroUsers" size="20px" class="secondary-user-badge__icon" />
        <span class="secondary-user-badge__text">{{ 'SECONDARY_ACCOUNT.TITLE' | translate }}</span>
      </div>
      }
      <app-notifications-menu (menuOpened)="closeHeaderDropdowns()" />
      <div class="header-menu-icon user">
        <div class="bueno-navbar-item">
          <a
            (mouseenter)="toggleMenuDropdown('user',$event, true)"
            (mouseleave)="toggleMenuDropdown('user', $event,false)"
            (click)="toggleMenuDropdown('user',$event, true)"
            class="bueno-navbar-link is-flex is-align-items-center"
            click-outside
            (outsideClick)="closeAllDropdowns()">
            @if (!isSecondary) {
            <mat-icon class="header-icon" svgIcon="bueno-user"></mat-icon>
            } @else {
            <mat-icon class="header-icon" svgIcon="bueno-user-2"></mat-icon>
            }

            <div [ngClass]="{'is-active': true, 'is-hidden': !userMenuActive}" class="bueno-navbar-dropdown user-menu">
              @for (item of userMenuItems; track item) { @if (item.isSubscription) {
              <a
                class="bueno-navbar-item-list is-flex is-align-items-center font-subtitle"
                (click)="launchCustomerPortal(); closeAllDropdowns(); $event.stopPropagation()">
                <mat-icon class="menu-icon" svgIcon="{{ item.icon }}"></mat-icon> {{ item.name |translate}}</a
              >
              } @else {
              <a
                class="bueno-navbar-item-list is-flex is-align-items-center font-subtitle"
                [routerLink]="item.url"
                (click)="closeAllDropdowns(); $event.stopPropagation()">
                <mat-icon class="menu-icon" svgIcon="{{ item.icon }}"></mat-icon> {{ item.name |translate}}</a
              >
              } }
              <app-button-primary
                class="bueno-navbar-item-list is-flex is-align-items-center button mb-2"
                (onClick)="onLogout(); closeAllDropdowns(); $event.stopPropagation()">
                {{'LOGOUT'|translate}}
              </app-button-primary>
            </div>
          </a>
        </div>
      </div>
      }
      <div class="header-menu-icon lang">
        <div class="bueno-navbar-item">
          <a
            (mouseenter)="toggleMenuDropdown('language',$event,true)"
            (mouseleave)="toggleMenuDropdown('language', $event,false)"
            (click)="toggleMenuDropdown('language',$event, true)"
            class="bueno-navbar-link is-flex is-align-items-center"
            click-outside
            (outsideClick)="closeAllDropdowns()">
            <mat-icon class="header-icon" svgIcon="bueno-earth"></mat-icon>
            <mat-icon
              [ngClass]="{open: languageDropdownActive}"
              class="header-arrow"
              svgIcon="bueno-arrow-down"></mat-icon>
            <div
              [ngClass]="{'is-active': languageDropdownActive, 'is-hidden': !languageDropdownActive}"
              class="bueno-navbar-dropdown">
              @for (lang of languagesList; track lang) {
              <a
                class="bueno-navbar-item-list font-subtitle"
                [ngClass]="{ 'is-active': language === lang.code }"
                (click)="setLanguage(lang.code.toUpperCase()); $event.stopPropagation()"
                >{{ lang.name }}</a
              >
              }
            </div>
          </a>
        </div>
      </div>
    </div>
  </nav>
</header>
